module.exports = __webpack_public_path__ + "media/images/lb/862-b3f8554d13588c4cb5d3b5cc97a6551e.svg";